import { BaseSetValueFromDialogStep } from './base-set-value-from-dialog-step';

export class SetValueFromDialogStep extends BaseSetValueFromDialogStep {

}
